import Game from '../GameEngine/Game.js'
import PlayerComputer from '../../../CribbageCore/src/Game/PlayerComputer.js';
import Cribbage from '../../../CribbageCore/src/Game/Cribbage.js';
import CribbageProxy from '../../../CribbageCore/src/Game/CribbageProxy.js';

import FlowControl from '../../../CribbageCore/src/Game/FlowControl.js';
import LoadScene from '../Scenes/LoadScene.js'
import GameScene from '../Scenes/GameScene.js'

export default class GameController {
  constructor(app, pageId) {
    this.app = app;
    this.pageId = 'Game';

    this.cribbage = null;
    this.game = null;
    this.isLoaded = false;
    this.tablePosition = "";
    this.initializePromise = null;
  }
  async show(path, data = {}) {
    const app = this.app;
    const pageId = this.pageId || path;

    let level = data.level;
    const computerName = data.computerName;
    const computerAvatar = data.computerAvatar;
    const tablePosition = data.tablePosition;

    //get path params
    const params = path.split("/");
    let levelPath = params[1];
    if (levelPath) level = levelPath;

    //get model
    let viewModel = {
      resource: app.resource,
      gameServer: app.gameServer,
      showLoading: !this.isLoaded
    };

    app.populate(pageId, viewModel);
    app.swapPage(pageId);

    if (level != "Online") {
      await this.startNewGame(level, computerName, computerAvatar);
    }
    // --> from - onjoinGameNetwork() "Game/Online"
    if (level == "Online") {
      await this.joinGameNetwork();
    }

    //get updated model
    let viewModelPostLoad = {
      resource: app.resource,
      gameServer: app.gameServer,
      isLoaded: this.isLoaded
    };
    app.populate(pageId, viewModelPostLoad);


    //refresh ui of game canvas on showing, otherwise it will be blank
    this.game.resize();
  }
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  async loadGameSafe() {
    //if loading is in progress, wait for it to finish. To prevent race condition.  
    //Alternatively, we can be sure to only load on app load and remove saving the promise.
    if (this.loadGamePromise) return this.loadGamePromise;
    this.loadGamePromise = this.loadGame();
    await this.loadGamePromise;
  }
  async loadGame() {
    let app = this.app;

    if (this.isLoaded === true) {
      return;
    }

    //used for race condition testing
    //await this.sleep(10000);

    //check for race contition
    if (this.isLoading) {
      throw new Error("GameController.loadGame() is already loading");
    }
    this.isLoading = true;


    if (!this.cribbage) this.cribbage = new Cribbage();

    let cribbage = this.cribbage;
    let audio = app.audio;
    if (this.game) {
      this.game.destroy();
      this.game = null;
    }

    this.game = new Game(800, 500, {
      width: 800, //it will be resized and overwriten 
      height: 500, //it will be resized and overwriten  
      //view: document.getElementById("game-canvas"),
      backgroundColor: 0x000000,
      resolution: window.devicePixelRatio || 1,
      clearBeforeRender: true,
      antialias: false,
      autoDensity: true
    });
    this.game.onError = this.gameOnError.bind(this);
    const gameScene = new GameScene(this, cribbage, audio);

    await this.game.loadScene(gameScene);

    this.isLoading = false;
    this.isLoaded = true;
  }
  gameOnError(error) {
    console.warn("game error: " + error);
    console.warn("This seems to be caused by Google Ads on Android.  Older versions of android seems to have a memory leak leaving old or unused ad pages open.  This also take the limited number of WebGL instances the browser can handle or crashing WebGL.");
    // console.log("reloading game...");
    // this.loadGame().then(() => {
    //    this.game.scene.reload(this.cribbage, this.tablePosition);
    // });
  }
  async startNewGame(level, computerName, computerAvatar) {
    const app = this.app;

    //initialize game if needed
    await this.loadGameSafe();

    //todo: cribbage game logic be created here 
    //note: could just have a single instance of cribbage and reset it
    if (this.cribbage) this.cribbage.destroy();
    this.cribbage = null;
    this.cribbage = new Cribbage();
    this.cribbage.debug = app.debug;
    this.cribbage.level = level;
    this.cribbage.event.addListener("stateChange", this.onStateChanged.bind(this));
    this.room = "";

    let name = app.userdata.name;
    let avatar = app.userdata.avatar;
    let rank = app.userdata.rank;
    let isChatMuted = app.userdata.isChatMuted;
    let board = app.userdata.board; //user settings
    let deck = app.userdata.deck; //user settings
    let background = app.userdata.background; //user settings
    if (name.indexOf("Player") !== -1) name = "You";
    this.cribbage.flowControl = new FlowControl(this.cribbage, 2000, 0);
    //todo: could be changed to plain data object for the human player.  It does not use any of the PlayerComputer logic
    this.cribbage.player1 = new PlayerComputer(this.cribbage, "player1", 0, "human", "none", name, avatar, rank);
    this.cribbage.player2 = new PlayerComputer(this.cribbage, "player2", 1000, "computer", level, computerName, computerAvatar);
    this.cribbage.isChatMuted = isChatMuted; //user settings
    this.cribbage.boardName = board; //user settings
    this.cribbage.deck = deck; //user settings
    this.cribbage.background = background; //user settings
    this.tablePosition = "player1";

    //skip ready state
    this.cribbage.action("start", null, "player1");
    this.cribbage.action("start", null, "player2");

    this.game.scene.reload(this.cribbage, this.tablePosition);

    if (app.appEvent) app.appEvent("gameStarted");

  }
  async joinGameNetwork() {
    const app = this.app;
    const tablePosition = app.gameServer.tablePosition;

    //initialize game if needed
    await this.loadGameSafe();

    if (this.cribbage) this.cribbage.destroy(); //needed to remove all listeners from the Game UI and app controller
    this.cribbage = null;
    //Race condition: needs to be before loadGameSafe(). await causes CribbageProxy to miss the first full sync message
    //or preloaded in app.js so loadGameSafe does not need to run
    //possible solution: preload game and then loadGameSafe() will not be needed
    //possible solution: CribbageProxy live in GameServer
    //possible solution: CribbageProxy asks GameServer for full sync when wired up
    this.cribbage = new CribbageProxy(app.gameServer);
    this.cribbage.debug = app.debug;
    this.cribbage.isChatMuted = app.userdata.isChatMuted;
    this.cribbage.boardName = app.userdata.board;
    this.cribbage.deck = app.userdata.deck;
    this.cribbage.background = app.userdata.background;
    this.cribbage.level = "Online";
    this.cribbage.event.addListener("stateChange", this.onStateChanged.bind(this));

    this.tablePosition = tablePosition;



    this.game.scene.reload(this.cribbage, tablePosition, "online");
    if (app.appEvent) app.appEvent("gameStarted");
    if (app.appEvent) app.appEvent("joinGameNetwork");
  }


  onStateChanged(state) {
    const app = this.app;

    let cribbage = this.cribbage;
    let tablePosition = this.tablePosition;
    let userdata = app.userdata;


    if (state === "endRound") {
      app.statistics.updateRoundStats(userdata, cribbage, tablePosition);
      //save userdata
      //this.save();
      //Had to disable because: Your data volume (93M hits) exceeds the limit of 10M hits per month as outlined in our Terms of Service. If you continue to exceed the limit, you will lose access to future data. Learn more about possible solutions
      ////analtyics: it is timing out because of the game is longer than 5 mintes causing a lower count on the real time report.
      let page = "Game";
      if (cribbage && cribbage.level) page = "Game/" + cribbage.level
      if(app.trackPage) app.trackPage(page, true);
    }
    if (state === "endMatch") {
      app.statistics.updateRoundStats(userdata, cribbage, tablePosition);
      app.statistics.updateMatchStats(userdata, cribbage, tablePosition);
      //save userdata
      app.save();
      if (app.appEvent) app.appEvent("endMatch");
    }

    if (state === "startRound" || state === "endRound" || state === "endMatch") {
      //check Achievements
      let achievements = app.achievements.checkForAchievementAndReward(userdata, userdata, cribbage, tablePosition);
      if (achievements) {
        //save userdata
        app.save();
      }
    }

    app.populate("GameInfo", app);
  }


  hideChat() {
    //hide chat popup
    let chatPopUp = document.getElementById("ChatPopUp");
    if (chatPopUp) {
      chatPopUp.style.display = "none";
    }
    //clear chat message
    let chatMessage = document.getElementById("chatMessage");
    if (chatMessage) {
      chatMessage.value = ""; //clear chat message
    }
  }
  sendChat(message) {
    //truncate message if needed - max length is 50
    message = message.substring(0, 50);

    //send chat
    if (this.cribbage && message) {
      let tablePosition = this.tablePosition;
      this.cribbage.action("chat", message, tablePosition);
    }
    //close on send
    this.hideChat();
  }


  ///////in game scene actions to the outside//////////////////
  quitGame() {
    const app = this.app;

    //go back if on bracketjd or in tournament iframe mode.
    var url = (window.location != window.parent.location)
      ? document.referrer
      : document.location.href;
    if (url.includes("bracketjd.com")) {
      window.history.back();
    }


    let level = "";
    if (this.cribbage)
      level = this.cribbage.level;

    //note: this is needed because the socket gets closed before the normal onStageChanged "endMatch" is catch from the socket server
    if (level === "Online") {
      //record a loss if online and was mid game
      let cribbage = this.cribbage;
      let userdata = app.userdata;
      let tablePosition = this.tablePosition;
      let allowQuit = cribbage.canQuit(tablePosition);
      if (!allowQuit) {
        //todo: give loss only if other player is still in game.
        //unfinished games count as a loss
        app.statistics.updateMatchStats(userdata, cribbage, tablePosition);
      }
      app.navigate("Online");

    } else {
      app.navigate("MainMenu");
    }
    return true;
  }
  blockPlayer(id, name) {
    this.app.blockPlayer(id, name)
  }
  addFriend(invitee) {
    this.app.addFriend(invitee)
  }
  showChat(allowFullChat) {
    const app = this.app;
    if (allowFullChat !== false) allowFullChat = true;

    const model = {
      resource: app.resource,
      allowFullChat: allowFullChat
    }

    //note: could use router or controller to show/hide full chat.  instead of swap page, just show the chat dialog

    //populate
    this.app.populate("ChatPopUp", model);

    //show chat popup
    let chatPopUp = document.getElementById("ChatPopUp");
    if (chatPopUp) {
      chatPopUp.style.display = "block";
    }




    //let fullChatTab = document.getElementById("chatTabFullChat");
    //let fullChatButton = document.getElementById("chatButtonFullChat");
    // if (fullChatTab && fullChatButton) {
    //   if (allowFullChat) {
    //     //fullChatTab.style.display = "block";
    //     fullChatButton.style.display = "block";
    //   }
    //   else {
    //     //fullChatTab.style.display = "none";
    //     fullChatButton.style.display = "none";
    //   }
    // }
  }
  muteSet(isMuted) {
    this.app.muteSet(isMuted);
  }
  showAnalyzeHand(data) {
    let analyzePopUp = document.getElementById("analyzePopUp");

    if (analyzePopUp) {
      analyzePopUp.style.display = "block";
    }
    let model = data;
    //data bind
    this.app.populate("analyzePopUp", model);
  }
  translate(message) {
    return this.app.translate(message);
  }
}